import React from "react";

interface LegalListProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Themed list wrapper matching pricing page style
 */
const LegalList: React.FC<LegalListProps> = ({ children, className = "" }) => (
  <ul className={`pricing-list list-unstyled ${className}`.trim()}>
    {children}
  </ul>
);

export default LegalList;
